import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './Fields.module.css';

class CheckBoxGroup extends React.Component {
  constructor(props) {
    super(props);
  }

  handleChange = (event) => {
    const target = event.currentTarget;
    let valueArray = [...this.props.value] || [];

    if (target.checked) {
      valueArray.push(target.id);
    } else {
      valueArray.splice(valueArray.indexOf(target.id), 1);
    }

    this.props.onChange(this.props.id, valueArray);
  };

  render() {
    const { value, classes, label, children } = this.props;

    return (
      <div className={classes}>
        <div>
          <label>{label}</label>
          {React.Children.map(children, (child) => {
            return React.cloneElement(child, {
              field: {
                value: value.includes(child.props.id),
                onChange: this.handleChange,
              },
            });
          })}
        </div>
      </div>
    );
  }
}

const RadioButtonGroup = ({ label, className, children }) => {
  return (
    <div className={className}>
      <fieldset>
        <legend>{label}</legend>
        {children}
      </fieldset>
    </div>
  );
};

CheckBoxGroup.propTypes = {
  value: PropTypes.any,
  classes: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.any,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  id: PropTypes.any,
};

RadioButtonGroup.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.any,
};

export { RadioButtonGroup, CheckBoxGroup };
